const LIKES_STORAGE_KEY = 'dulceLikedProducts';
const LEGACY_LIKES_KEY = 'likedProducts';

const readLikedIds = () => {
    try {
        const current = localStorage.getItem(LIKES_STORAGE_KEY);
        if (current) {
            const parsed = JSON.parse(current);
            return Array.isArray(parsed) ? parsed : [];
        }

        const legacy = localStorage.getItem(LEGACY_LIKES_KEY);
        if (legacy) {
            const parsed = JSON.parse(legacy);
            if (Array.isArray(parsed)) {
                localStorage.setItem(LIKES_STORAGE_KEY, JSON.stringify(parsed));
                return parsed;
            }
        }
    } catch {
        // ignore parse errors
    }
    return [];
};

export const isProductLikedLocally = (productId) =>
    readLikedIds().includes(productId);

export const setProductLikedLocally = (productId, liked) => {
    if (!productId) return;

    let ids = readLikedIds();

    if (liked) {
        if (!ids.includes(productId)) {
            ids = [...ids, productId];
        }
    } else {
        ids = ids.filter((id) => id !== productId);
    }

    localStorage.setItem(LIKES_STORAGE_KEY, JSON.stringify(ids));
};

export const isLikedByUser = (likedBy, reviewerId) =>
    Array.isArray(likedBy) && likedBy.includes(reviewerId);
